/* src/app/main/pages/apps/emission-calculator/emission-calculator.component.css */
.app-img {
  width: 65px;
  height: 65px;
}
.back-link {
  color: #E8882D;
  font-family: "D-DIN";
  font-size: 16px;
}
.back-link .fa-angle-left {
  font-weight: 600;
}
.apps-form-input {
  background-color: #213654;
  padding: 8px 10px;
  margin-top: 30px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 6px #00000029;
}
.apps-form-input label {
  margin-right: 10px;
  margin-bottom: 0px;
  font-weight: 600;
}
.apps-form-input .form-control {
  font-size: 15px;
  height: auto;
  border-radius: 0;
  padding: 3px 10px;
  border: none;
  margin-right: 10px;
  font-family: "D-DIN";
  width: 100%;
  background-color: #fff;
}
.emission-calculator-cargo .form-control {
  font-size: 14px;
  height: auto;
  border-radius: 0;
  padding: 8px 12px;
  border: none;
  font-family: "Roboto";
  border-radius: 0;
  background-color: #F0F0F0;
  border-left: 3px solid #0B2A7D !important;
  border: 1px solid rgb(11 42 125 / 0.2);
}
@media all and (-ms-high-contrast: none) {
  .emission-calculator-cargo .form-control {
    line-height: 0.5;
  }
}
.emission-calculator-cargo .form-control:disabled {
  background-color: #bebebe;
}
.emission-calculator-cargo .btn-search {
  background-color: #E8882D;
  border: none;
  color: #FFFFFF;
  border-radius: 0px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 14px;
  padding: 8px 36px;
  font-family: "D-DIN-Bold";
  margin-right: 60px;
}
.bg-gray {
  background-color: #F5F5F5;
  box-shadow: 0px 3px 6px #00000029;
}
@media (min-width: 1440px) {
  .back-link {
    font-size: 24px !important;
  }
  .apps-form-input label {
    font-size: 17px;
  }
  .apps-form-input .form-control {
    width: 85%;
  }
  .bg-gray p {
    font-size: 18px;
  }
  .emission-calculator-cargo .form-control {
    font-size: 18px;
  }
  .emission-calculator-cargo .btn-search {
    font-size: 19px;
    padding: 8px 40px;
  }
}
@media (device-width: 1280px) {
  .apps-form-input .form-control {
    width: 92%;
  }
}
@media (device-width: 1024px) {
  .apps-form-input label {
    width: 100%;
  }
  .border-after::after {
    right: 16px;
  }
  .apps-form-input .form-control {
    width: 80%;
  }
}
@media (max-width: 767px) {
  .apps-form-input label,
  .apps-form-result label {
    width: 100%;
  }
  .apps-form-input label {
    margin-bottom: 10px;
  }
  .bg-gray {
    margin-bottom: 30px;
  }
  .apps-form-input {
    padding: 15px 10px;
  }
  .apps-form-input .form-group {
    text-align: center;
  }
  .app-img {
    width: 60px;
    height: 60px;
    margin-top: 10px;
  }
  .emission-calculator .back-link {
    margin-bottom: 5px;
  }
}
.invalid-feedback {
  display: block;
}
.form-group {
  margin-bottom: 1rem !important;
}
#tableResult th {
  background-color: #ccc;
}
.loader {
  position: absolute;
  background-color: #cccccc6e;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
}
.loader-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: auto;
  text-align: center;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
.table.table-bordered thead th {
  border: 1px solid #dee2e6;
  padding: 0.9em;
}
.table.table-bordered tbody tr td {
  border: 1px solid #dee2e6;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=emission-calculator.component.css.map */
